import React, {useEffect, useState} from "react";
import code from "../../lib/appfuse-react/core/code";
import Box from "../../lib/appfuse-react/component/Box";
import {FormControlLabel, FormLabel, Radio, RadioGroup} from "@material-ui/core";
import i18n from "../../lib/appfuse-react/core/i18n";
import lang from "../../lib/appfuse-react/core/lang";

function Radios(props) {
    const {value, required, valueAccessor='value', textAccessor='text', onChange, disabled, style={}, readOnly, disabledOptions=[]} = props;
    const [codeData, setCodeData] = useState([]);
    const title = lang.isString(props.title) ? i18n.translate(props.title) : props.title;

    useEffect(() => {
        (async () => {
            if(props.code) {
                const codeData = await code.fetch(props.code);
                setCodeData(codeData);
            }
        })();
    }, [props.code]);

    let options;
    if(props.options) {
        options = props.options;
    } else if(props.code) {
        options = codeData;
    } else {
        options = [];
    }

    if (readOnly) style.pointerEvents = 'none';

    return (
        <Box>
            <FormLabel component="legend" required={required}>{title}</FormLabel>
            <RadioGroup row value={value} onChange={onChange} >
                {
                    options.map(option => {

                        let disabled = props.disabled;
                        if (disabledOptions.includes(option[valueAccessor])) {
                            disabled = true;
                        }

                        return (
                            <FormControlLabel value={option[valueAccessor]} control={<Radio color="secondary" />} label={option[textAccessor]} disabled={disabled} style={style} />
                        )
                    })
                }
            </RadioGroup>
        </Box>
    )
}

export default Radios;